module.exports = __webpack_public_path__ + "img/Logistics-Waybills.e4128062.jpg";